import React from 'react';
import { BrowserRouter as Router, useRoutes, useLocation } from 'react-router-dom';
import adminRoutes from './config/adminRoutes';
import CanonicalSetter from './components/canonicalSetter';
import { SEOHead } from './components/SEOHead';
import { useUpdateSEO } from './hooks/useSEO';
import siteRoutes from './config/siteRoutes';


const App: React.FC = () => {
  const location = useLocation();
  
  // Mettre à jour le SEO basé sur la route
  useUpdateSEO();
  
  const routes = [...siteRoutes, ...adminRoutes];
  const routing = useRoutes(routes);
    
  return (
    <>
      <SEOHead />
      {routing}
    </>
  );
};

const AppWrapper: React.FC = () => {
  return (
    <Router>
      <CanonicalSetter />
      <App />
    </Router>
    
  );
};

export default AppWrapper;